import { Badge, Row } from "react-bootstrap"
import Slider from "react-slick"
import styled from "styled-components"
import Image from "next/image"

export const ActivitiesGrid = styled(Row)`
  display: flex;
  flex-wrap: wrap;
`

export const ActivitySliderWrapper = styled(Slider)`
  & * > .slick-slide > div {
    margin: 0 16px 0 8px !important;
  }
  & > .slick-list {
    padding: 1rem 0 0.5rem 0 !important;
  }
  @media (max-width: 601px) {
    & > .slick-prev, .slick-next {
      display: none !important;
    }
  }
  & > .slick-prev, .slick-next {
    cursor: pointer;
  }
  & > .slick-prev::before, .slick-next::before {
    content: none;
  }
`

export const ActivityCard = styled.div`
  border-radius: 20px;
  overflow: hidden;
  text-align: left;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 12px 0 rgba(0, 0, 0, 0.19);
  margin-bottom: 16px;
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
  }
`

export const ActivityBannerSlider = styled(Slider)`
  cursor: pointer;
  & > .slick-dots li button:before {
    font-size: 12px;
    text-align: center;
  }
`

export const ActivityBannerSliderImage = styled(Image)`
  max-height: 500px;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  margin: auto;
  &:hover {
  }
`

export const StyledBox = styled.div`
  position: absolute;
  text-align: left;
  font-weight: bolder;
  font-size: 1.5em;
  @media (max-width: 601px) {
    font-size: 1.1em;
    & > img {
      max-width: 320px;
    }
  }
`

export const StyledBoxHeader = styled.div`
  position: absolute;
  top: 5px;
  left: 42px;
  color: white;
  text-transform: uppercase;
  @media (max-width: 601px) {
    top: 8px;
  }
`

export const StyledOverlay = styled.div`
  border-radius: 16px;
  margin-top: 24px;
  padding: 48px 24px 36px 48px;
  text-align: left;
  @media (max-width: 601px) {
    padding: 24px 0 18px 0;
  }
`

export const SkillBadge = styled(Badge)`
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: ${props => props.color}
`

export const LiveBadge = styled(Badge)`
  position: absolute;
  bottom: 8px;
  left: 8px;
  color: rgba(0,0,0,0.5);
  background-color: white !important;
`
